import * as React from "react";
import * as Router from "react-router-dom";
import { To } from "history";
import { VssNavigation } from "./VssNavigation";
import "./Link.scss";

export interface ILink {
    disabled?: boolean;
}

export const Link = (props: Router.LinkProps & ILink) => {
    const navigate = Router.useNavigate();

    const resolveHref = (to: To): string => {
        return typeof to === "string"
            ? Router.generatePath(to)
            : Router.createPath(to);
    };

    const isAbsoluteUrl = (href: string): boolean =>
        /^(?:[a-z]+:)?\/\//i.test(href);

    const onClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        if (props.onClick) {
            props.onClick(e);
        }
        if (e.defaultPrevented || isModifiedEvent(e) || !isLeftClickEvent(e)) {
            return;
        }

        navigate(props.to);
        e.preventDefault();
    };

    const isModifiedEvent = (e: React.MouseEvent) => {
        return !!(e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
    };

    const isLeftClickEvent = (e: React.MouseEvent) => {
        return e.button === 0;
    };

    const className = props.disabled
        ? `${props.className ?? ""} disabled-link`
        : props.className;

    // Check for absolute URLs on the raw prop BEFORE calling resolveHref,
    // because generatePath() mangles absolute URLs (interprets the colon
    // in "https:" as a route parameter delimiter in react-router 6.30+).
    const rawTo = typeof props.to === "string" ? props.to : "";
    if (isAbsoluteUrl(rawTo)) {
        return (
            <a
                href={rawTo}
                onClick={props.onClick}
                className={className}
            >
                {props.children}
            </a>
        );
    }

    const href = resolveHref(props.to);

    return (
        <Router.Link
            {...props}
            to={VssNavigation.getHubUrl() + href}
            onClick={(e) => onClick(e)}
            className={className}
        />
    );
};
